import { Button, BUTTON_TYPES } from '../../../../../components/Button'
import { ACTIONS, contractSubject, SUBJECTS } from '../../../Abilities'
import { Can } from 'features/ContractDetails/Providers/ContractDetailsAbilityProvider'
import { useContractDetailsPopup } from '../../../Providers/ContractDetailsPopupProvider'
import { useContractDetailsContext } from '../../../Providers/ContractDetailsContextProvider'
import { BTN_TXT } from '../../../../../constants'
import { ReactComponent as More16 } from 'assets/svg/More16.svg'
import { AddLOPCellProps } from './types'
import VersionHistoryPopup from '../../../../../components/Container/WithHistory/VersionHistoryPopup/VersionHistoryPopup'
import usePopup from '../../../../../hooks/usePopup'
import { VersionHistory } from './VersionHistory'

export const AddLOPCell = ({ selectedHSRow }: AddLOPCellProps) => {
  const contractDetailsContext = useContractDetailsContext()
  const { addAmendmentPopup } = useContractDetailsPopup()

  const { getVersionHistoryForHS } = contractDetailsContext.actions

  const versionHistoryPopupProps = usePopup({
    title: 'Version history',
    width: 675
  })

  const actions = selectedHSRow.amendment_document
    ? [
        {
          text: BTN_TXT.EDIT_LOP,
          onClick: () => addAmendmentPopup.actions.open({ selectedHSRow })
        },
        {
          text: BTN_TXT.VIEW_VERSION_HISTORY,
          onClick: () => {
            versionHistoryPopupProps.actions.open()
            getVersionHistoryForHS({
              hsId:
                selectedHSRow.hospital_level && selectedHSRow.hs_uuid
                  ? selectedHSRow.hs_uuid
                  : selectedHSRow.uuid,
              hospitalId: selectedHSRow.hospital_level
                ? selectedHSRow.uuid
                : null
            })
          },
          hidden: !selectedHSRow.has_document_history
        }
      ]
    : [
        {
          text: BTN_TXT.ADD_LOP_DOCUMENT,
          onClick: () => addAmendmentPopup.actions.open({ selectedHSRow })
        }
      ]

  const { hospital_level, hs_amendment_document, amendment_document } =
    selectedHSRow
  if (hospital_level && hs_amendment_document && !amendment_document)
    return null

  return (
    <Can
      I={ACTIONS.SUBMIT}
      a={contractSubject(SUBJECTS.LOP, contractDetailsContext?.state?.details)}
    >
      <Button.Menu
        icon={<More16 />}
        type={BUTTON_TYPES.GHOST}
        options={actions.filter((action) => !action.hidden)}
        iconOnly
        hideArrow
        medium
      />
      <VersionHistoryPopup
        {...versionHistoryPopupProps.state}
        {...versionHistoryPopupProps.actions}
        children={<VersionHistory />}
      />
    </Can>
  )
}
